<template>
  <section class="m-social-feed" 
    :class="{'cx-sec': hasInfoFeed || hasImgFeed}"
    ref="container">
    <div class="cx-wrap--page m-wrap--page" v-show="hasInfoFeed || hasImgFeed">
      <div class="cx-row">
        <div class="cx-col-md-6 cx-col-sm-12 cx-div">
          <h2 :aria-label="$t('home.socialMediaHeading_1')" class="cx-t20 m-social-feed__title"
            v-html="$t('home.socialMediaHeading_1') + '<br>' +$t('home.socialMediaHeading_2')"
          ></h2>
        </div>
        <div class="cx-col-md-6 cx-col-sm-12 cx-div">
          <div class="-fade cx-t01">{{$t('footer.stayConnected')}}</div>
          <ul class="cx-list--sm m-sociallist">
            <social-media-subscription-button 
              v-for="(s, type) in subscriptions"
              :key="`${type}-${$i18n.locale}`"
              :type="type"
              :subscriptions="s"
            />
          </ul>
        </div>
        <div :class="`cx-col-lg-${hasImgFeed ? 6 : 12}`" v-if="hasInfoFeed">
          <cx-slider-v2 barPager cycling>
            <cx-slider-item 
              v-for="feedEntry in feeds.infos"
              :key="feedEntry.id">
              <template slot-scope="slotProps">
                <div v-if="feedEntry.feeds && feedEntry.feeds.length > 0"
                  class="m-social-feed__subtitle">
                  <a 
                    @focus="slotProps.focusHandler"
                    @blur="slotProps.blurHandler"
                    :href="feedEntry.pageUrl" 
                    target="_blank" class="cx-t01 -fade" >
                    <i :class="networkIcon[feedEntry.feeds[0].network_id]"></i>
                    {{feedEntry.feeds[0].user_full_name || feedEntry.feeds[0].user_screen_name || ''}}
                  </a> 
                </div>

                <div v-for="feed in feedEntry.feeds"
                  :key="feed.id"
                  class="m-social-feed__article">
                  <a 
                    @focus="slotProps.focusHandler"
                    @blur="slotProps.blurHandler"
                    :title="getTextDescription(feed)"
                    :href="feed.url" target="_blank">
                    <article class="cx-row--flat -v-center -j-between">
                      <div class="cx-col">
                        <div class="cx-t01 -fade cx-div--sm" 
                          v-html="feed.text">
                        </div>
                      </div>
                      <div class="cx-col" v-if="hasImage(feed)">
                        <div class="cx-media">
                          <cx-img 
                            class="cx-media__img -round" 
                            :class="{ '--play-able': !!feed.video || feed.image.includes('video') }"
                            tag='div'
                            :imgSrc="`${feed.image}`"
                            skipQueryParse
                          ></cx-img>
                        </div>
                      </div>
                    </article>
                  </a>
                </div> 
              </template>
            </cx-slider-item>
          </cx-slider-v2>     
        </div>

        <div :class="`cx-col-lg-${hasInfoFeed ? 6 : 12}`" v-if="hasImgFeed">         
          <cx-slider-v2 barPager cycling>
            <cx-slider-item 
              v-for="feedEntry in feeds.imgs"
              :key="feedEntry.id">
              <template slot-scope="slotProps">
                <div v-if="feedEntry.feeds && feedEntry.feeds.length > 0"
                  style="padding: 0 1px"
                  class="m-social-feed__subtitle">
                  <a 
                    @focus="slotProps.focusHandler"
                    @blur="slotProps.blurHandler"
                    :href="feedEntry.pageUrl" 
                    target="_blank" class="cx-t01 -fade" >
                    <i :class="networkIcon[feedEntry.feeds[0].network_id]"></i>
                    {{feedEntry.feeds[0].user_full_name || feedEntry.feeds[0].user_screen_name || ''}}
                  </a> 
                </div>
                <div class="cx-row--halfgutter" ref="imgFeeds">
                  <div v-for="feed in feedEntry.feeds"
                    :key="feed.id"
                    :class="`${hasInfoFeed ? '' : 'cx-col-lg-2'} cx-col-sm-4 cx-col-xs-6 cx-div`">
                    <a 
                      @focus="slotProps.focusHandler"
                      @blur="slotProps.blurHandler"
                      :href="feed.url"
                      :title="getTextDescription(feed)"
                      rel="noopener noreferrer" target="_blank">
                      <div class="cx-media">
                        <cx-img class="cx-media__img -round-corner"
                          :class="{ '--play-able': !!feed.video }"
                          tag='div'
                          :imgSrc="feed.image"
                          skipQueryParse
                        ></cx-img>
                      </div>
                    </a>
                  </div>
                </div>
              </template>
            </cx-slider-item>
          </cx-slider-v2>   
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import SocialMediaSubscriptionButton from "@/components/SocialMediaSubscriptionButton";
import lazyLoadHelper from "@/mixins/lazyLoadHelper";
import FacebookEmoji from "@/utils/emoji-facebook";
import TwitterEmoji from "@/utils/emoji-twitter";
import { getSocialFeedText, escapeSocialFeedText } from "@/utils/socialFeedText";

export default {
  name: "home-social-media",
  mixins: [lazyLoadHelper],
  uit() {
    return [
      ["home", ["socialMediaHeading_1", "socialMediaHeading_2"]],
      ["footer", ["stayConnected"]],
      [
        "socialMedia",
        [
          "facebook",
          "weibo",
          "weixin",
          "twitter",
          "instagram",
          "youtube",
          "pinterest",
          "vk",
          "globe",
          "homeHeader1",
          "homeHeader1Type",
          "homeHeader2",
          "homeHeader2Type",
        ],
      ],
    ];
  },
  data() {
    return {
      fbemoji: null,
      twemoji: null,
      sliderHeight: "unset",
      networkIcon: {
        1: "fab fa-x-twitter",
        2: "fab fa-instagram",
        3: "fab fa-facebook",
        4: "fab fa-pinterest",
        5: "fab fa-google-plus-g",
        6: "fas fa-globe",
        7: "fas fa-globe",
        8: "fab fa-youtube",
        9: "fab fa-tumblr",
        10: "fas fa-globe",
        11: "fas fa-globe",
        // ...
        25: "fab fa-tiktok",
        xiaohongshu: "fa-kit fa-xiaohongshu",
        weixin: "fab fa-weixin",
        weibo: "fab fa-weibo",
        douyin: "fab fa-tiktok",
      },
    };
  },
  components: {
    SocialMediaSubscriptionButton,
  },
  created() {
    if (typeof TwitterEmoji !== "undefined") {
      this.twemoji = new TwitterEmoji(
        "https://content.macaotourism.gov.mo/uploads/emoji/twitter/",
      );
    }

    if (typeof FacebookEmoji !== "undefined") {
      this.fbemoji = new FacebookEmoji(
        "https://content.macaotourism.gov.mo/uploads/emoji/facebook/",
      );
    }
  },
  mounted() {
    this.checkIsMobile()
      ? this.lazyLoad(this.$refs.container, this.loadFeeds, {
          rootMargin: "500px",
        })
      : this.loadFeeds();
  },
  computed: {
    ...mapState({
      blackAndWhite: (state) => state.ui.blackAndWhite,
    }),
    subscriptions: function() {
      let raw = this.$store.getters["socialmedia/getSubscription"](
        this.$i18n.locale,
      );

      const results = {};

      raw.forEach(({ type, name, link }) => {
        if (results[type] == undefined) {
          results[type] = [];
        }

        results[type].push({
          name,
          link,
        });
      });

      return results;
    },
    feeds() {
      const feeds =
        this.$store.getters["socialmedia/getFeed"](this.$i18n.locale) || {};
      return {
        infos: this.parseEmoji(feeds.infoFeeds || []),
        imgs: this.parseEmoji(feeds.imgFeeds || []),
      };
    },
    hasInfoFeed() {
      return (
        !this.blackAndWhite && this.feeds.infos && this.feeds.infos.length > 0
      );
    },
    hasImgFeed() {
      return (
        !this.blackAndWhite && this.feeds.imgs && this.feeds.imgs.length > 0
      );
    },
  },
  methods: {
    parseEmoji: function(feeds) {
      return feeds.map((feedsGroup) => {
        return {
          ...feedsGroup,
          feeds: feedsGroup.feeds.map((feed) => {
            const rawText = getSocialFeedText(feed.text);
            const linkTitle = this.parseHtmlToShortDesc(
              rawText,
              this.hasImage(feed) ? 130 : 200,
              10,
              false,
            );
            let text = escapeSocialFeedText(linkTitle);

            if (feed.network_id == 1 && this.twemoji) {
              text = this.twemoji.convert(linkTitle);
            }

            if (feed.network_id == 3 && this.fbemoji) {
              text = this.fbemoji.convert(linkTitle);
            }

            return {
              ...feed,
              text,
              linkTitle,
            };
          }),
        };
      });
    },
    hasImage: function(feed) {
      return feed.image;
    },
    loadFeeds: function() {
      !this.blackAndWhite &&
        this.$store.dispatch("socialmedia/FETCH_FEED", {
          locale: this.$i18n.locale,
        });
    },
    getTextDescription: function(feed) {
      const getMediaCaption = (feed) => {
        if (feed.linkTitle) return feed.linkTitle;

        if (feed.text) return this.getPlainText(feed.text).substring(0, 20);

        if (feed.data && feed.data.length >= 1 && feed.data[0].value)
          return this.getPlainText(feed.data[0].value);

        if (feed.user_screen_name) return feed.user_screen_name;

        return "";
      };

      const socialMediaName = feed.network_name || "";
      const caption = getMediaCaption(feed);

      // https://3.basecamp.com/3633946/buckets/6317965/todos/6673089971#__recording_6908774021
      if (socialMediaName && caption) {
        return socialMediaName + " - " + caption;
      } else if (caption) {
        return caption;
      }
      return socialMediaName;
    },
    getPlainText: function(text) {
      return getSocialFeedText(text);
    },
  },
};
</script>

<style lang="scss">
.m-social-feed {
  &__title {
    @extend %style-title;
  }
  &__subtitle {
    text-align: left;
    margin-bottom: $space-sm;
    padding: 0 $space-base;

    > a,
    > a.cx-t01.-fade {
      transition: color 150ms ease;

      &:hover,
      &:focus {
        color: #008a28 !important;
      }
    }
  }
  &__articles {
    @include set-font(0.8);
    @include normalize-link($color-primary);
    position: relative;
    &:after {
      content: "";
      @include pos-abs-full;
      pointer-events: none;
      border-radius: $br-base;
      left: $space-base;
      right: $space-base;
      width: auto;
      border: 1px solid rgba(162, 162, 162, 0.3);
    }
  }
  &__article {
    text-align: left;
    padding: $space-base;
    &:not(:last-child) {
      border-bottom: 1px solid rgba(162, 162, 162, 0.3);
    }

    > a {
      transition: color 300ms ease;

      &:hover,
      &:focus {
        color: #008a28 !important;
      }

      .cx-t01 {
        transition: color 300ms ease;
      }

      &:hover .cx-t01,
      &:focus .cx-t01 {
        color: #008a28 !important;
      }
    }
  }
  .cx-col-lg-6 {
    margin-bottom: $space-base;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .cx-media__caption {
    padding: $space-sm;
  }
  .--play-able::after {
    position: absolute;
    top: 0;
    left: 2px;
    width: 100%;
    height: 100%;
    color: #ffffff;
    font-family: "Font Awesome 6 Pro";
    font-weight: 900;
    font-size: 2.5em;
    opacity: 0.8;
    text-shadow: 0 0 0.1em black;
    content: "\f04b";
    z-index: 1;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .cx-media__img.-round-corner {
    transition: box-shadow 300ms ease;
    box-shadow: 0 0 0 0 #008a28 inset;
  }

  a {
    &:hover,
    &:focus {
      // Only apply to the right-side thumbnail grid images
      // (avoid adding outline to left-side info feed images with `-round`)
      .cx-media__img.-round-corner {
        box-shadow: 0 0 0 2px #008a28 inset;
      }
    }
  }
}
.m-sociallist {
  & > li {
    font-size: $font-lg;
    a {
      color: inherit;
    }
  }
}
</style>
